import { defaultTheme } from "_constants";
import { useCustomerManagementStore } from "_hooks";
import React from "react";
import { MdLogout } from "react-icons/md";
import { PuffLoader } from "react-spinners";
import PropTypes from "prop-types";

const AppLogoutIcon = (props) => {
  const { isActionable = false } = props;
  const {
    customerManagement: { logoutStatus },
    logout,
  } = useCustomerManagementStore();

  const loading = logoutStatus === "loading";
  return (
    <>
      {loading ? (
        <PuffLoader color={defaultTheme.theme.palette.text.primary} size={24} />
      ) : (
        <MdLogout size={24} onClick={isActionable ? logout : null} />
      )}
    </>
  );
};
AppLogoutIcon.propTypes = {
  isActionable: PropTypes.bool,
};
export default AppLogoutIcon;
